"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StrictFieldInfoTooltip = exports.STRICT_TOOLTIP_TEXT = exports.SEARCHABLE_OPTIONS_THRESHOLD = void 0;
exports.useLookupOptions = useLookupOptions;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _hoverTooltip = require("./hover-tooltip");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var SEARCHABLE_OPTIONS_THRESHOLD = exports.SEARCHABLE_OPTIONS_THRESHOLD = 8;
var STRICT_TOOLTIP_TEXT = exports.STRICT_TOOLTIP_TEXT = "This must match an existing option — a custom value may not be accepted on save.";
var StrictFieldInfoTooltip = exports.StrictFieldInfoTooltip = function StrictFieldInfoTooltip(_ref) {
  var text = _ref.text,
    delayDuration = _ref.delayDuration;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_hoverTooltip.HoverTooltip, {
    content: text,
    side: "top",
    align: "start",
    className: "inline-flex cursor-help",
    delayDuration: delayDuration,
    "data-sentry-element": "HoverTooltip",
    "data-sentry-component": "StrictFieldInfoTooltip",
    "data-sentry-source-file": "lookup-options.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.InfoIcon, {
      className: "text-foreground-muted",
      "aria-label": "Strict field information",
      "data-sentry-element": "InfoIcon",
      "data-sentry-source-file": "lookup-options.tsx"
    })
  });
};
function useLookupOptions(optionsUrl, fetchLookupOptions) {
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    fetched = _useState2[0],
    setFetched = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    loadError = _useState6[0],
    setLoadError = _useState6[1];
  (0, _react.useEffect)(function () {
    setFetched([]);
    setLoadError(null);
    if (!optionsUrl) return;
    if (!fetchLookupOptions) {
      setLoadError("This field has no options configured.");
      return;
    }
    var cancelled = false;
    setIsLoading(true);
    setLoadError(null);
    fetchLookupOptions(optionsUrl).then(function (options) {
      if (!cancelled) setFetched(options);
    }).catch(function () {
      if (!cancelled) setLoadError("Failed to load options.");
    }).finally(function () {
      if (!cancelled) setIsLoading(false);
    });
    return function () {
      cancelled = true;
    };
  }, [optionsUrl, fetchLookupOptions]);
  return {
    options: fetched,
    isLoading: isLoading,
    loadError: loadError
  };
}